<div class="py-4 px-0">
  <div class="container">
    <ul class="list-inline material-form-tabs" [ngClass]="uploadActive ? 'navigation-disabled': ''">
      <li class="list-inline-item">
        <a [routerLink]="['/lisaa-oppimateriaali', 1]" [routerLinkActive]="['active']">
          {{ "forms.educationalResource.nav.files" | translate }}
        </a>
      </li>
      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>
      <li class="list-inline-item">
        <a [routerLink]="['/lisaa-oppimateriaali', 2]" [routerLinkActive]="['active']">
          {{ "forms.educationalResource.nav.basicDetails" | translate }}
        </a>
      </li>
      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>
      <li class="list-inline-item">
        <a [routerLink]="['/lisaa-oppimateriaali', 3]" [routerLinkActive]="['active']">
          {{ "forms.educationalResource.nav.educationalDetails" | translate }}
        </a>
      </li>
      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>
      <li class="list-inline-item">
        <a [routerLink]="['/lisaa-oppimateriaali', 4]" [routerLinkActive]="['active']">
          {{ "forms.educationalResource.nav.extendedDetails" | translate }}
        </a>
      </li>
      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>
      <li class="list-inline-item">
        <a [routerLink]="['/lisaa-oppimateriaali', 5]" [routerLinkActive]="['active']">
          {{ "forms.educationalResource.nav.licenseDetails" | translate }}
        </a>
      </li>
      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>
      <li class="list-inline-item">
        <a [routerLink]="['/lisaa-oppimateriaali', 6]" [routerLinkActive]="['active']">
          {{ "forms.educationalResource.nav.basedOnDetails" | translate }}
        </a>
      </li>
      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>
      <li class="list-inline-item">
        <a [routerLink]="['/lisaa-oppimateriaali', 7]" [routerLinkActive]="['active']">
          {{ "forms.educationalResource.nav.preview" | translate }}
        </a>
      </li>
    </ul>
    @switch (tabId) {
      @case (1) {
        <app-tabs-files
          [educationalMaterialID$]="educationalMaterialID$"
          [uploadedFiles$]="uploadedFiles$"
          (emitterAbort)="openConfirmModal($event, confirmAbort)"
          (emitterEducationalMaterialID)="updateEducationalMaterialID($event)"
        (emitterUploadActive)="setUploadActive($event)"></app-tabs-files>
      }
      @case (2) {
        <app-tabs-basic-details
        (abortEdit)="openConfirmModal($event, confirmAbort)"></app-tabs-basic-details>
      }
      @case (3) {
        <app-tabs-educational-details
        (abortEdit)="openConfirmModal($event, confirmAbort)"></app-tabs-educational-details>
      }
      @case (4) {
        <app-tabs-extended-details
        (abortEdit)="openConfirmModal($event, confirmAbort)"></app-tabs-extended-details>
      }
      @case (5) {
        <app-tabs-license (abortEdit)="openConfirmModal($event, confirmAbort)"></app-tabs-license>
      }
      @case (6) {
        <app-tabs-based-on-details
        (abortEdit)="openConfirmModal($event, confirmAbort)"></app-tabs-based-on-details>
      }
      @case (7) {
        <app-preview
          [educationalMaterialID$]="educationalMaterialID$"
          [uploadedFiles$]="uploadedFiles$"
        (abortEdit)="openConfirmModal($event, confirmAbort)"></app-preview>
      }
    }
  </div>
  <ng-template #confirmAbort>
    <div class="modal-body text-center">
      <p>{{ "forms.editEducationalResource.abort.text" | translate }}</p>
      <button type="button" class="btn btn-blue" (click)="abort()">
        {{ "forms.editEducationalResource.abort.confirm" | translate }}
      </button>
      <button type="button" class="btn btn-outline-blue" (click)="confirmModalRef.hide()">
        {{ "forms.editEducationalResource.abort.cancel" | translate }}
      </button>
    </div>
  </ng-template>
</div>
